<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <mat-select
    aria-label="Weekday"
    [(ngModel)]="weekday"
    (ngModelChange)="emitValue()"
    [disabled]="disabledByFieldset"
  >
    <mat-option [value]="0">Sunday</mat-option>
    <mat-option [value]="1">Monday</mat-option>
    <mat-option [value]="2">Tuesday</mat-option>
    <mat-option [value]="3">Wednesday</mat-option>
    <mat-option [value]="4">Thursday</mat-option>
    <mat-option [value]="5">Friday</mat-option>
    <mat-option [value]="6">Saturday</mat-option>
  </mat-select>
</mat-form-field>
